'use client';
import ConnectButton from '@/components/widgets/ConnectButton';
import Topbar from './Topbar';
import CurrencySelect from '@/components/widgets/CurrencySelect';
import ThemeToggle from '@/components/widgets/ThemeToggle';
import OverlayMenu from './OverlayMenu';
import Search from './Search';
import NetworkSelect from '@/components/widgets/NetworkSelect';
import { useNetwork } from '@nftx/react';
import { Network } from 'nftx.js';
import { BountyButton } from '@/components/widgets/BountyButton';

export default function TopbarContainer({
  withNavigation,
}: {
  withNavigation?: boolean;
}) {
  const isTestnet = useNetwork() === Network.Sepolia;

  return (
    <Topbar
      withNavigation={!!withNavigation}
      isTestnet={isTestnet}
      connectButton={<ConnectButton />}
      currencySelect={<CurrencySelect />}
      networkSelect={<NetworkSelect />}
      themeToggle={<ThemeToggle />}
      search={<Search />}
      overlayMenu={<OverlayMenu />}
      bountyButton={<BountyButton />}
    />
  );
}
